//Library Imports
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// application components goes here
import BubbleProgressPopup from '../../../Common/Components/BubbleProgressPopup';
import Mainnav from 'modules/Common/Components/Mainnav';

const ContactsImport: React.FC = () => {
  const [importAnimation, setImportAnimation] = useState(true);
  let history = useNavigate();

  useEffect(() => {
    setTimeout(function () {
      setImportAnimation(false);
    }, 6000);
  }, []);
  if (!importAnimation) {
    history('/content/search'); // redirecting to Smart Content as required in WB 4.0
  }
  return <div>{importAnimation ? <BubbleProgressPopup /> : <></>}</div>;
};

export default ContactsImport;
